import React, { useContext } from "react";
import Button from "../../uiComponents/Button";
import { ModalContext } from "../../ModalContext";
import { useDispatch } from "react-redux";
import { signOut } from "../../../store/actions/user";

const LogoutModal = ({
  closeModal,
}) => {
  const { handleModal } = useContext(ModalContext);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(signOut());
    handleModal();
  };

  return (
    <div className="modal_container">
      <p className="modal_title">Are you sure you want to log out?</p>
      <div className="modal_btns">
        <Button
          transparent={true}
          clickFunction={closeModal}
        >
          Cancel
        </Button>

        <Button
          clickFunction={handleClick}
        >
          Log out
        </Button>
      </div>
    </div>
  );
};

export default LogoutModal;
